import { isEmpty } from 'lodash';
import { reactive, toRefs } from 'vue';

const state = reactive({
  items: [],
});

const toast = {
  show: (toast) => {
    add(toast);
  },
  success: (toast) => {
    add({ ...toast, type: 'success' });
  },
  warning: (toast) => {
    add({ ...toast, type: 'warning' });
  },
  error: (toast) => {
    add({ ...toast, type: 'danger' });
  },
  info: (toast) => {
    add({ ...toast, type: 'info' });
  },
};

const add = (toast) => {
  if (!isEmpty(toast)) {
    if (state.items.length > 3) remove(3);

    state.items.unshift({
      key: Symbol(),
      ...toast,
    });
  }
};

const remove = (index) => {
  state.items.splice(index, 1);
};

export default () => {
  return {
    ...toRefs(state),
    remove,
    toast,
  };
};
